import {useContext, useEffect, useState} from 'react'
import {CustomerReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import CustomerGroupReportRow from './CustomerGroupReportRow'
import {parseCustomerGroupReportRow} from '../../parsings'
import {CUSTOMER_GROUP_REPORT_COLUMNS, formatCountAndPrice, keysToSum} from '../../utils'
import {formatToIndianNumber, formatPrice} from '../../../../utils/common'
import CustomerGroupTableHeader from '../header/CustomerGroupTableHeader'

const CustomerGroupReportTable = () => {
  const {
    customerGroupData,
    isCustomerGroupLoading,
    onCustomerGroupSortingChange,
    customerGroupFilters,
  } = useContext(CustomerReportContext)
  const [summedState, setSummedState] = useState<any>({})

  useEffect(() => {
    const summed: any = {}

    customerGroupData.forEach((row) => {
      keysToSum.forEach((key) => {
        const sumKey = `total_${key}`
        summed[sumKey] = (summed[sumKey] || 0) + (row[key] || 0)
      })
    })

    setSummedState(summed)
  }, [customerGroupData])

  return (
    <div className='card border mb-10'>
      <div className='card-body p-7'>
        <CustomerGroupTableHeader />
        <DynamicTable
          data={customerGroupData}
          sortableColumns={CUSTOMER_GROUP_REPORT_COLUMNS}
          loading={isCustomerGroupLoading}
          TableRow={CustomerGroupReportRow}
          noDataMessage='No customer group reports found'
          filters={customerGroupFilters}
          onSortingChange={onCustomerGroupSortingChange}
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          rowParsingFunction={parseCustomerGroupReportRow}
          tableFooter={({columnTotals}: any) => (
            <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
              <tr>
                <td>TOTAL</td>
                <td>{formatToIndianNumber(columnTotals.total_order_count)}</td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_freeship_coupon_count,
                    summedState?.total_freeship_discount
                  )}
                </td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_sf_coupon_count,
                    summedState?.total_sf_discount
                  )}
                </td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_sll_coupon_count,
                    summedState?.total_sll_discount
                  )}
                </td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_5offoneorder_coupon_count,
                    summedState?.total_5offoneorder_discount
                  )}
                </td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_other_coupon_count,
                    summedState?.total_other_discount
                  )}
                </td>
                <td>{formatPrice(columnTotals.total_discount, false)}</td>
              </tr>
            </tfoot>
          )}
        />
      </div>
    </div>
  )
}

export default CustomerGroupReportTable
